export const GET_TPV_CHART_DATA = "GET_TPV_CHART_DATA";
export const GET_TPV_MODAL_DATA = "GET_TPV_MODAL_DATA";
export const GET_INCIDENT_CHART_DATA = "GET_INCIDENT_CHART_DATA";
export const GET_INCIDENT_MODAL_DATA = "GET_INCIDENT_MODAL_DATA";
export const GET_PREVENTIVE_CHART_DATA = "GET_PREVENTIVE_CHART_DATA";
export const GET_PREVENTIVE_MODAL_DATA = "GET_PREVENTIVE_MODAL_DATA";
export const GET_WORK_REQUEST_CHART_DATA = "GET_WORK_REQUEST_CHART_DATA";
export const GET_WORK_REQUEST_MODAL_DATA = "GET_WORK_REQUEST_MODAL_DATA";
export const STORE_LIST = "STORE_LIST";
export const INCIDENT_CODE = "INCIDENT_CODE";
export const API_CALL_STATUS = "API_CALL_STATUS";
export const PREVENTIVE_MAINTENANCE_DATA = "PREVENTIVE_MAINTENANCE_DATA";
export const THIRD_PARTY_AUDIT_DATA = "THIRD_PARTY_AUDIT_DATA";
export const MAINTENANCE_INCIDENT_DATA = "MAINTENANCE_INCIDENT_DATA";
export const WORK_REQUEST_DATA = "WORK_REQUEST_DATA";
export const ASSET_HEALTH_WEIGHT = "ASSET_HEALTH_WEIGHT";
